import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useSound } from "@/lib/SoundContext";

export default function FridgeButton({ variant = "close", onOpen, className = "", style = {}, captionClass = "text-ink/70" }) {
  const { play } = useSound();
  const navigate = useNavigate();
  const isOpen = variant === "open";

  const handle = (e) => {
    e.stopPropagation();
    if (isOpen) {
      if (onOpen) onOpen();
    } else {
      play("door");
      try { sessionStorage.removeItem("fridge-open"); } catch (err) {}
      navigate("/", { replace: true });
    }
  };

  return (
    <div className={`flex flex-col items-center gap-1.5 ${className}`} style={style}>
      <motion.button
        type="button"
        data-testid={isOpen ? "open-fridge-button" : "close-fridge-button"}
        onClick={handle}
        className="relative rounded-full border-[4px] border-ink px-7 py-3 font-display text-base sm:text-lg text-white shadow-[0_7px_0_rgba(43,35,32,0.45)] cursor-pointer"
        style={{ background: "radial-gradient(circle at 32% 28%, #FF7A6B 0%, #E8402F 45%, #B01E10 100%)" }}
        whileHover={{ scale: 1.07, rotate: -1.5 }}
        whileTap={{ scale: 0.92, y: 5, boxShadow: "0 2px 0 rgba(43,35,32,0.45)" }}
      >
        <span className="absolute left-[16%] top-[12%] w-[40%] h-[26%] rounded-full bg-white/50 blur-[3px] pointer-events-none" />
        {isOpen ? "OPEN FRIDGE" : "CLOSE FRIDGE"}
      </motion.button>
      <span className={`font-hand text-xs sm:text-sm ${captionClass}`}>
        {isOpen ? "scrumptious portfolio awaits" : "that's all folks!"}
      </span>
    </div>
  );
}
